<template>     
     <div>
   

   
         <ForgetPassword/>
       
  </div>
  
</template>

<script>
import ForgetPassword from '@/components/Auth/ForgetPassword.vue';
export default {
components: {
      ForgetPassword,
    },
}
</script>

<style scoped>

</style>
